import React from 'react';
import AppsHeader from '@tenant/core/AppsContainer/AppsHeader';
import { Box, Breadcrumbs, Tab, Typography } from '@mui/material';
import AppTooltip from '@tenant/core/AppTooltip';
import IntlMessages from '@tenant/utility/IntlMessages';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { ROUTE_STRING } from 'constants/RouteString';
import { Link, useParams } from 'react-router-dom';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Code } from 'react-content-loader';
import { Editor } from '@monaco-editor/react';
import useGetLogRepository from 'redux/slices/dockerImage/hooks/useGetLogRepository';
import useGoBack from '@tenant/utility/hooks/useGoBack';
import AppsContainer from '@tenant/core/AppsContainer';

const ViewLog = () => {
  const goBack = useGoBack();
  const [value, setValue] = React.useState('Logs');
  const { lastRunId } = useParams();
  const { data, isLoading, isRefetching } = useGetLogRepository({ lastRunId });
  const loading = isLoading || isRefetching;

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const onClickBackButton = () => {
    goBack(ROUTE_STRING.DOCKER_IMAGE.LIST);
  };

  return (
    <AppsContainer
      fullView
      title={
        <Breadcrumbs aria-label='breadcrumb'>
          <Typography color='text.primary'>Library</Typography>
          <Typography color='text.primary'>
            <Link to={ROUTE_STRING.DOCKER_IMAGE.LIST}>Docker Repositories</Link>
          </Typography>
          <Typography color='text.primary'>{lastRunId}</Typography>
        </Breadcrumbs>
      }
    >
      <TabContext value={value}>
        <AppsHeader>
          <Box
            display={'flex'}
            justifyContent={'space-between'}
            sx={{ width: '100%' }}
          >
            <Box
              sx={{
                display: 'flex',
                cursor: 'pointer',
                alignItems: 'center',
                gap: 4,
              }}
              component='span'
              mr={{ xs: 2, sm: 4 }}
            >
              <AppTooltip title={<IntlMessages id='common.back' />}>
                <ArrowBackIcon
                  sx={{
                    color: 'text.secondary',
                  }}
                  onClick={onClickBackButton}
                />
              </AppTooltip>

              <Box sx={{ ml: 2, mb: -3 }}>
                <TabList
                  onChange={handleChange}
                  aria-label='lab API tabs example'
                >
                  <Tab label='Logs' value='Logs' />
                  <Tab label='Error Message' value='Error Message' />
                </TabList>
              </Box>
            </Box>
          </Box>
        </AppsHeader>
        <Box>
          <TabPanel value='Logs'>
            {loading && (
              <Box sx={{ height: 'calc(100vh - 275px)' }}>
                <Code />
              </Box>
            )}

            {!loading && (
              <Editor
                height='calc(100vh - 275px)'
                defaultLanguage='log'
                value={data?.data?.Logs}
                options={{
                  minimap: { enabled: false },
                  automaticLayout: true,
                  wordWrap: 'on',
                  scrollBeyondLastLine: false,
                  readOnly: true,
                }}
              />
            )}
          </TabPanel>
          <TabPanel value='Error Message'>
            <Editor
              height='calc(100vh - 275px)'
              defaultLanguage='log'
              value={data?.data?.Error}
              options={{
                minimap: { enabled: false },
                automaticLayout: true,
                wordWrap: 'on',
                scrollBeyondLastLine: false,
                readOnly: true,
              }}
            />
          </TabPanel>
        </Box>
      </TabContext>
    </AppsContainer>
  );
};

export default React.memo(ViewLog);

ViewLog.propTypes = {};
